export default {
  // Page Title
  'products.title': '화장품 용기 찾기 및 커스터마이징',
  'products.subtitle': '검증된 포장 제품을 검색하고, 사양을 비교하며, 맞춤 포장 견적을 요청하세요.',

  // Search
  'products.pageTitle': '나만의 화장품 포장 찾기',
  'products.search.placeholder': '제품명, 용량, 재질, SKU로 검색',
  'products.search.button': '검색',
  'products.search.imageSearch': '이미지로 검색',
  'products.imageSearch.uploadDescription': '참고 이미지를 업로드하여 유사한 포장을 찾아보세요.',

  // Category Tabs
  'products.category.airless': '에어리스 병',
  'products.category.pump': '펌프 병',
  'products.category.spray': '스프레이 병',
  'products.category.dropper': '드로퍼 병',
  'products.category.cream': '크림 단지',
  'products.category.foam': '폼 병',
  'products.category.tubes': '튜브',
  'products.category.caps': '캡 & 펌프',
  'products.category.sample': '샘플 용기',
  'products.category.aluminum': '알루미늄 용기',
  'products.category.glass': '유리 용기',
  'products.category.pet': 'PET / PETG 병',
  'products.category.all': '전체',

  // Sidebar
  'products.sidebar.title': '카테고리',
  'products.sidebar.noCategories': '카테고리 정보가 없습니다',

  // Category tree (sidebar)
  'products.categories.glass': '유리용기',
  'products.categories.glass.toner': '스킨토너용',
  'products.categories.glass.creamJar': '크림(Jar타입)',
  'products.categories.glass.ampoule': '앰플용',
  'products.categories.petg': 'PETG(PET) 용기',
  'products.categories.petg.serum': '에센스용',
  'products.categories.petg.toner': '스킨토너용',
  'products.categories.petg.creamJar': '크림(Jar타입)',
  'products.categories.petg.shampoo': '샴푸용 대용량',
  'products.categories.airless': '진공용기',
  'products.categories.airless.serum': '에센스용',
  'products.categories.airless.toner': '스킨토너용',
  'products.categories.airless.creamJar': '크림(Jar타입)',
  'products.categories.specialty': '특수용기',
  'products.categories.specialty.syringe': '주사기타입',
  'products.categories.specialty.powder': '파우더용기',
  'products.categories.specialty.cleansingPad': '클렌징패드용기',
  'products.categories.specialty.sample': '샘플용기',
  'products.categories.specialty.accessories': '악세서리(소모품)',
  'products.categories.tubes': '튜브(Tube)',
  'products.categories.tubes.eyeCream': '아이크림용',
  'products.categories.tubes.flipScrew': '원터치(스크루)용',
  'products.categories.tubes.brushSponge': '브러쉬(스폰지)용',
  'products.categories.tubes.rollerComb': '롤러(콤브)용 튜브',
  'products.categories.tubes.airlessPump': '진공펌프용',
  'products.categories.tubes.makeup': '메이크업용',
  'products.categories.tubes.toothpaste': '치약용 튜브',
  'products.categories.tubes.aluminum': '알루미늄 튜브',
  'products.categories.pumpsDroppers': '펌프&스포이드',
  'products.categories.pumpsDroppers.mist': '미스트',
  'products.categories.pumpsDroppers.dropper': '스포이드',
  'products.categories.pumpsDroppers.oilPump': '오일펌프',
  'products.categories.pumpsDroppers.serumPump': '에센스펌프',
  'products.categories.pumpsDroppers.shampooPump': '샴푸펌프',
  'products.categories.pumpsDroppers.trigger': '건스프레이',
  'products.categories.pumpsDroppers.caps': '캡(CAP)',
  'products.categories.sheetPouch': '원단(파우치)',
  'products.categories.sheetPouch.mask': '마스크팩용',
  'products.categories.sheetPouch.cleansing': '클렌징(스킨)용',
  'products.categories.sheetPouch.specialty': '특수용',
  'products.categories.sheetPouch.pouch': '파우치',
  'products.categories.boxes': '상자(BOX)',
  'products.categories.boxes.folding': '단상자',
  'products.categories.boxes.giftSet': '세트',
  'products.categories.boxes.round': '원형(다각형)',
  'products.categories.boxes.outer': '외박스',
  'products.categories.makeup': '메이크업용기',
  'products.categories.makeup.cushion': '쿠션용기',
  'products.categories.makeup.lip': '립용기',
  'products.categories.makeup.puff': '퍼프(Puff)',
  'products.categories.makeup.other': '기타',
  'products.categories.misc': '기타',
  'products.categories.misc.labels': '스티커',
  'products.categories.misc.pvcFilm': 'PVC필름',

  // Filters
  'products.filters.title': '필터',
  'products.filters.category': '카테고리',
  'products.filters.capacity': '용량',
  'products.filters.material': '재질',
  'products.filters.shape': '형태',
  'products.filters.neckSize': '넥 사이즈 / 클로저 사이즈',
  'products.filters.usage': '용도 / 적용',
  'products.filters.priceRange': '가격대',
  'products.filters.moqRange': 'MOQ 범위',
  'products.filters.moqAvailable': 'MOQ 있음',
  'products.filters.inStock': '재고 있음',
  'products.filters.clearAll': '필터 초기화',
  'products.filters.apply': '필터 적용',
  'products.filters.showResults': '결과 보기',
  'products.filters.mobileTitle': '제품 필터',
  'products.filters.supplyType': '공급 유형',
  'products.filters.allSupplyTypes': '전체 공급 유형',
  'products.filters.availabilityStatus': '가용성',
  'products.filters.allAvailability': '전체 가용성',

  // Capacity options
  'products.capacity.5ml': '5ml',
  'products.capacity.10ml': '10ml',
  'products.capacity.15ml': '15ml',
  'products.capacity.20ml': '20ml',
  'products.capacity.30ml': '30ml',
  'products.capacity.50ml': '50ml',
  'products.capacity.60ml': '60ml',
  'products.capacity.100ml': '100ml',
  'products.capacity.120ml': '120ml',
  'products.capacity.150ml': '150ml',
  'products.capacity.200ml': '200ml',
  'products.capacity.250ml': '250ml',
  'products.capacity.300ml': '300ml',
  'products.capacity.500ml': '500ml',

  // Material options
  'products.material.pet': 'PET',
  'products.material.petg': 'PETG',
  'products.material.pp': 'PP',
  'products.material.pe': 'PE',
  'products.material.abs': 'ABS',
  'products.material.acrylic': '아크릴',
  'products.material.glass': '유리',
  'products.material.aluminum': '알루미늄',
  'products.material.pcr': 'PCR',
  'products.material.mono': '모노소재',

  // Toolbar
  'products.toolbar.found': '{{count}}개 포장 제품 발견',
  'products.toolbar.clearFilters': '필터 초기화',
  'products.toolbar.sortBy': '정렬',
  'products.toolbar.gridView': '그리드',
  'products.toolbar.listView': '목록',
  'products.toolbar.allCategories': '전체 카테고리',

  // Sort options
  'products.sort.newest': '최신순',
  'products.sort.nameAsc': '제품명 가나다순',
  'products.sort.nameDesc': '제품명 역순',
  'products.sort.priceLow': '낮은 예상 가격순',
  'products.sort.priceHigh': '높은 예상 가격순',
  'products.sort.capacityLow': '용량: 낮은 순',
  'products.sort.capacityHigh': '용량: 높은 순',
  'products.sort.recentlyUpdated': '최근 업데이트',

  // 가용성 상태
  'products.availability.available': '구매 가능',
  'products.availability.limitedStock': '재고 한정',
  'products.availability.checkAvailability': '재고 확인 필요',
  'products.availability.madeToOrder': '주문 제작',

  // Product Card
  'products.card.sku': 'SKU: {{sku}}',
  'products.card.noSku': 'SKU: —',
  'products.card.moq': 'MOQ: {{moq}}개',
  'products.card.moqFree': '소량가 (Free)',
  'products.card.moqShort': 'MOQ {{moq}}개',
  'products.card.finishedProduct': '후가공상품',
  'products.card.delivery': '배송: {{days}}일',
  'products.card.leadTime': '리드타임',
  'products.card.leadTimeDaysSingle': '{{days}}일',
  'products.card.leadTimeDaysRange': '{{min}}–{{max}}일',
  'products.card.capacityMl': '{{ml}}ml',
  'products.card.deliveryDays': '딜리버리: {{days}}일',
  'products.card.deliveryLabel': '딜리버리',
  'products.card.orderMethod': '주문방식',
  'products.card.basePrice': '기준단가',
  'products.card.specsSeparator': '|',
  'products.card.priceApprox': '약 {{currency}} {{price}} / 개',
  'products.card.priceEstimated': '{{currency}} {{price}} / 개부터',
  'products.card.priceNote': '검토 후 최종 견적',
  'products.card.requestQuote': '견적 요청',
  'products.card.viewDetails': '상세 보기',
  'products.card.aiPreview': 'AI 미리보기',
  'products.card.checkAvailability': '재고 확인',
  'products.card.saved': '저장됨',
  'products.card.save': '저장',
  'products.card.loginToSave': '저장하려면 로그인',

  // Specs
  'products.specs.capacity': '용량',
  'products.specs.material': '재질',
  'products.specs.shape': '형태',
  'products.specs.neckSize': '넥 사이즈',
  'products.specs.size': '사이즈',

  // Empty State
  'products.empty.title': '제품을 찾을 수 없습니다',
  'products.empty.message': '필터를 조정하거나 참고 이미지를 업로드하여 유사한 포장을 찾아보세요.',
  'products.empty.noAvailable': '구매 가능한 제품이 없습니다. 필터를 조정하거나 다른 가용성 옵션을 확인해보세요.',
  'products.empty.noLimitedStock': '재고 한정 제품이 없습니다. 필터를 조정해보세요.',
  'products.empty.noCheckAvailability': '재고 확인이 필요한 제품이 없습니다. 필터를 조정해보세요.',
  'products.empty.noMadeToOrder': '주문 제작 제품이 없습니다. 필터를 조정해보세요.',
  'products.empty.clearFilters': '필터 초기화',
  'products.empty.imageSearch': '이미지로 유사 제품 찾기',

  // Pagination
  'products.pagination.showing': '{{total}}개 중 {{start}}–{{end}}개',
  'products.pagination.prev': '이전',
  'products.pagination.next': '다음',

  // Bottom CTA
  'products.bottomCTA.title': '적합한 포장을 찾는 데 도움이 필요하신가요?',
  'products.bottomCTA.text': '참고 이미지를 업로드하거나 담당 팀에 맞춤 포장 견적을 요청하세요.',
  'products.bottomCTA.imageSearch': '이미지로 유사 제품 찾기',
  'products.bottomCTA.requestQuote': '견적 요청',

  // Market indicator
  'products.market.label': '마켓',
  'products.currency.label': '통화',
  'products.baseCurrency.label': '기준 견적 통화',

  // Search status
  'products.searchingByImage': '이미지 기반 검색 중...',
  'products.searchingProducts': '제품 검색 중...',
  'products.imageSearchResult': '업로드한 이미지와 유사한 제품 {{count}}개를 찾았습니다.',
  'products.textSearchResult': '「{{query}}」 검색 결과 {{count}}개를 찾았습니다.',
  'products.noSimilarProducts': '유사한 제품을 찾지 못했습니다. 다른 이미지를 사용해보세요.',
  'products.noProductsFoundForQuery': '「{{query}}」 검색 결과가 없습니다. 검색어를 조정해보세요.',
  'products.imageSearchFailed': '이미지 검색에 실패했습니다. 다른 이미지로 다시 시도해주세요.',
  'products.imageSearchUnavailable': '이미지 검색 서버가 현재 사용 불가능합니다.',
  'products.apiRouteNotFound': 'API 경로를 찾을 수 없습니다. Cursor API 경로 /api/customer/image-search 및 프록시 설정을 확인해주세요.',
  'products.showingAllProducts': '대신 모든 제품을 보여드립니다.',
  'products.textSearchLocalFallback': '서버 검색을 사용할 수 없습니다. 로컬 결과 {{count}}개를 표시합니다. "{{query}}"',
  'products.searchFailed': '검색에 실패했습니다. 다시 시도해주세요.',
  'products.clearSearch': '검색 초기화',
  'products.imageSearchLabel': '이미지 검색',
  'products.textSearchLabel': '텍스트 검색',

  // Image Search Flow
  'products.imageSearch.uploaded': '이미지 업로드 완료.',
  'products.imageSearch.jobCreated': '이미지 검색 작업 생성 완료.',
  'products.imageSearch.startingEdgeFunction': 'Edge Function 실행 중...',
  'products.imageSearch.analyzingImage': '이미지 분석 중...',
  'products.imageSearch.searchingSimilar': '유사 상품 검색 중...',
  'products.imageSearch.preparingResults': '검색 결과 정리 중...',
  'products.imageSearch.completed': '업로드한 이미지와 유사한 제품 {{count}}개를 찾았습니다.',
  'products.imageSearch.failed': '이미지 검색에 실패했습니다. 다른 이미지를 사용해보세요.',
  'products.imageSearch.signInRequired': '이미지 검색을 사용하려면 로그인해주세요.',
  'products.imageSearch.invalidFile': 'JPG, PNG, WEBP 파일만 지원합니다.',
  'products.imageSearch.tooLarge': '이미지는 10MB 이하여야 합니다.',
  'products.imageSearch.timeout': '이미지 검색이 예상보다 오래 걸리고 있습니다. 이 페이지를 열어두거나 다시 시도해보세요.',
  'products.imageSearch.edgeFunctionFailed': 'Edge Function을 시작할 수 없습니다. 다시 시도해주세요.',

  // Image Search Monitor
  'products.imageSearch.monitor.title': '이미지 검색 모니터',
  'products.imageSearch.monitor.jobId': '작업 ID',
  'products.imageSearch.monitor.status': '상태',
  'products.imageSearch.monitor.step': '단계',
  'products.imageSearch.monitor.progress': '진행률',
  'products.imageSearch.monitor.message': '메시지',
  'products.imageSearch.monitor.uploadedImage': '업로드된 이미지',
  'products.imageSearch.monitor.createdAt': '생성 시각',
  'products.imageSearch.monitor.startedAt': '시작 시각',
  'products.imageSearch.monitor.completedAt': '완료 시각',
  'products.imageSearch.monitor.errorCode': '에러 코드',
  'products.imageSearch.monitor.errorMessage': '에러 메시지',
  'products.imageSearch.monitor.timeline': '타임라인',
  'products.imageSearch.monitor.invokeStatus': 'Function Invoke',
  'products.imageSearch.monitor.invokeInvoking': '실행 중...',
  'products.imageSearch.monitor.invokeInvoked': '실행 완료',
  'products.imageSearch.monitor.invokeFailed': '실행 실패',

  // Image Search Modal
  'products.imageSearch.modalTitle': '이미지로 검색',
  'products.imageSearch.dropHere': '이미지를 여기에 끌어오세요',
  'products.imageSearch.orClick': '또는 클릭해서 파일 선택',
  'products.imageSearch.upload': '업로드',
  'products.imageSearch.camera': '카메라',
  'products.imageSearch.takePhoto': '카메라로 촬영',
  'products.imageSearch.reupload': '다시 선택',
  'products.imageSearch.cancel': '취소',
  'products.imageSearch.searchButton': '유사 제품 찾기',

  // List page misc
  'products.clearResult': '결과 지우기',
  'products.filters.activeCount': '{{count}}개 적용됨',
  'products.filters.noShapeData': '형태 데이터가 아직 없습니다.',
  'products.filters.noNeckSizeData': '넥 사이즈 데이터가 아직 없습니다.',
  'products.filters.noUsageData': '용도 데이터가 아직 없습니다.',
  'products.filters.noPriceData': '가격 데이터가 아직 없습니다.',
  'products.filters.noMoqData': 'MOQ 데이터가 아직 없습니다.',
  'products.card.noImage': '이미지 없음',

  // Detail page
  'detail.breadcrumbHome': '홈',
  'detail.breadcrumbPackaging': '용기',
  'detail.addedToCart': '장바구니에 추가되었습니다! ({{count}}개)',
  'detail.loading': '상품 정보를 불러오는 중...',
  'detail.notFoundTitle': '상품을 찾을 수 없습니다',
  'detail.notFoundDesc': '해당 상품이 존재하지 않거나 삭제되었습니다.',
  'detail.backToList': '상품 목록으로 돌아가기',
  'detail.inquiry': '문의',
  'detail.leadTime': '리드타임',
  'detail.selectedFinishing': '선택된 후가공 ({{count}})',
  'detail.reset': '초기화',
  'detail.finishingNote': '후가공 미리보기에서 선택됨 · 견적 요청 시 자동 반영됩니다',
  'detail.priceReference': '참고 가격',
  'detail.perUnit': '개당',
  'detail.requestQuoteInquiry': '견적 문의',
  'detail.orderQuantity': '주문 수량(MOQ)',
  'detail.priceEstimateNote': '이 금액은 예상금액 이며 견적서 작성시 금액이 확정 됩니다',
  'detail.moqBelowTitle': '최소 주문 수량(MOQ) 미달',
  'detail.moqBelowDesc': '이 제품의 MOQ는 {{moq}}입니다. MOQ 미만 주문 시 추가 비용이 발생하거나 주문이 거절될 수 있습니다.',
  'detail.sampleOnly': '샘플만 구매',
  'detail.samplePriceNote': '참고 가격이며 수량별 단가·후가공·환율 및 최종 거래조건은 견적서에서 확인됩니다.',
  'detail.samplePurchase': '샘플 구매',
  'detail.sampleRange': '(0-50개)',
  'detail.sampleBasePrice': '샘플 참고가격',
  'detail.tabDetails': '제품 상세',
  'detail.tabReviews': '구매 후기',
  'detail.specifications': '제품 사양',
  'detail.features': '주요 특징',
  'detail.saveProduct': '저장',
  'detail.shareProduct': '공유',
  'detail.addToCart': '장바구니',
  'detail.requestQuote': '후가공 &견적 받기',
  'detail.noReviews': '아직 리뷰가 없습니다',
  'detail.noReviewsDesc': '이 제품의 첫 번째 구매 후기를 남겨보세요.',
  'detail.reviewCount': '{{count}}개 리뷰',
  'detail.expand': '더 보기',
  'detail.collapse': '접기',
  'detail.noSpecs': '등록된 제품 사양이 없습니다.',
  'detail.noImage': '이미지가 없습니다',
  'detail.imageNotAvailable': '이미지를 불러올 수 없습니다',
  'detail.myFinishingImages': '내 후가공 이미지',

  // Finishing preview page
  'finishing.title': '후가공 미리보기',
  'finishing.material': '재질',
  'finishing.capacity': '용량',
  'finishing.moq': 'MOQ',
  'finishing.refPrice': '참고 단가',
  'finishing.quoteInquiry': '견적 문의',
  'finishing.selectOptions': '후가공 옵션 선택',
  'finishing.selectOptionsDesc': '부위 → 후가공 방법 → 색상 순서로 선택해주세요. 여러 부위를 각각 다르게 지정할 수 있습니다.',
  'finishing.resetAll': '전체 초기화',
  'finishing.selectPart': '부위 선택',
  'finishing.selectMethod': '후가공 방법',
  'finishing.selectColor': '색상 선택',
  'finishing.done': '선택 완료',
  'finishing.methodsCount': '{{count}}가지 방법',
  'finishing.selectPartFirst': '- 부위를 먼저 선택하세요',
  'finishing.selectPartHint': '왼쪽에서 부위를 선택하면<br />적용 가능한 후가공 방법이 표시됩니다.',
  'finishing.selectMethodFirst': '- 방법을 먼저 선택하세요',
  'finishing.confirmHint': '- 확인 버튼을 눌러주세요',
  'finishing.selectMethodHint': '중앙에서 후가공 방법을 선택하면<br />색상을 지정할 수 있습니다.',
  'finishing.popularColors': '인기 컬러',
  'finishing.premium': 'Premium',
  'finishing.custom': '직접 입력',
  'finishing.changeColor': '색상 변경',
  'finishing.changeColorHint': '색상을 변경하거나 다른 후가공 방법을 선택할 수 있습니다.',
  'finishing.reselect': '다시선택',
  'finishing.confirm': '확인',
  'finishing.selectedCount': '선택된 후가공 {{count}}건',
  'finishing.optionsIncluded': '견적 요청 시 이 옵션들이 함께 전달됩니다.',
  'finishing.generating': '생성 중...',
  'finishing.aiPreviewButton': 'AI 후가공 미리보기',
  'finishing.original': '원본',
  'finishing.aiFinished': 'AI 후가공',
  'finishing.aiGenerating': 'AI 이미지 생성 중...',
  'finishing.aiFailed': 'AI 이미지 생성 실패',
  'finishing.aiFailedHint': '원본 이미지와 선택한 후가공 정보를 참고해주세요.',
  'finishing.retry': '다시 시도',
  'finishing.aiImage': 'AI 후가공 이미지',
  'finishing.aiImageHint': '후가공 옵션을 선택하고<br />AI 이미지처리 버튼을 눌러주세요',
  'finishing.summary': '후가공 요약',
  'finishing.summaryDesc': '선택한 후가공 조건이 서버로 구조화된 JSON 형태로 전송됩니다. 서버에서 AI 프롬프트를 생성하여 이미지를 제작합니다.',
  'finishing.selectionSummary': '선택 요약',
  'finishing.additionalRequest': '추가 요청사항 (선택)',
  'finishing.additionalRequestHint': '추가 요청사항은 구조화된 후가공 조건과 함께 서버로 전송됩니다.',
  'finishing.generatePreview': '미리보기 생성',
  'finishing.progressTitle': '미리보기 생성 진행 상황',
  'finishing.currentStatus': '현재 상태',
  'finishing.elapsed': '경과 시간',
  'finishing.message': '메시지',
  'finishing.complete': '미리보기 완료',
  'finishing.aiPreview': 'AI 미리보기',
  'finishing.generateAgain': '다시 생성',
  'finishing.useThisPreview': '이 미리보기 사용',
  'finishing.viewEstimate': '후가공 견적 보기',
  'finishing.failed': '미리보기 생성 실패',
  'finishing.retryBtn': '재시도',
  'finishing.editOptions': '옵션 수정',
  'finishing.cancelAndBack': '취소하고 돌아가기',
  'finishing.applySave': '후가공 {{count}}건 적용 저장',
  'finishing.saveUse': '후가공 이미지 저장 사용',
  'finishing.colorCount': '{{count}}색',
  'finishing.cancel': '취소',
  'finishing.pantoneCode': 'Pantone 코드',
  'finishing.hexCode': '색상 코드 (HEX)',
  'finishing.customColorHint': '원하는 Pantone 번호와 색상을 직접 입력하세요.',
  'finishing.pantonePlaceholder': '예: Pantone 185 C',
  'finishing.noPantone': 'Pantone 미지정',
  'finishing.selectThisColor': '이 색상으로 선택',
  'finishing.customName': 'Custom',
  'finishing.pantoneRequired': 'Pantone 코드를 입력해주세요.',
  'finishing.hexInvalid': '올바른 HEX 색상 코드를 입력해주세요. (예: #FF6B6B)',
  'finishing.metallic': '메탈릭',
  'finishing.pearl': '펄',
  'finishing.softTouch': '소프트터치',
  'finishing.additionalRequestPlaceholder': '예: "프리미엄 느낌으로 해주세요."\n"깨끗한 스튜디오 배경으로 해주세요."\n"병을 우아하고 미니멀하게 유지해주세요."',
};